import { Truck, Shield, CreditCard, Package } from 'lucide-react';

const PERKS = [
  { icon: Truck, text: 'Free Shipping Over ₹ 1,999' },
  { icon: Package, text: 'Pan-India Delivery' },
  { icon: Shield, text: '100% Authentic Models' },
  { icon: CreditCard, text: 'Secure Payments' },
];

export default function TrustBar() {
  // Mobile (<sm): 2x2 grid so all 4 perks are visible without
  // horizontal scrolling. Desktop: single row, centred, comfortable
  // gaps. Previous build used `overflow-x-auto` which created a hidden
  // scrollable region — mobile users reported "stuff going off screen".
  return (
    <section data-testid="trust-bar" className="bg-[#1A1A1A] py-3">
      <div className="max-w-7xl mx-auto px-4 md:px-12">
        <div className="grid grid-cols-2 gap-y-2 gap-x-3 sm:flex sm:items-center sm:justify-center sm:gap-8 md:gap-16">
          {PERKS.map(p => (
            <div key={p.text} className="flex items-center gap-1.5 sm:gap-2 min-w-0">
              <p.icon size={13} className="text-[#FF2A2A] flex-shrink-0" />
              <span className="text-[10px] sm:text-[11px] font-semibold tracking-wide text-white/80 whitespace-nowrap truncate">{p.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
